import layout from '@/layout'

export default {
  path: '/in',
  component: layout,
  redirect: '/in/index',
  name: 'inIndexs',
  meta: {
    title: '测试',
    icon: 'goods'
  },
  children: [
    {
      path: '/in/verson',
      name: 'verson_index',
      component: () => import('@/views/verson/index.vue'),
      meta: {
        title: '测试',
        icon: 'verson'
      }
    },
    {
      path: '/in/index',
      name: 'inIndex',
      component: () => import('@/views/in/index'),
      meta: {
        title: '进货管理',
        icon: 'goods'
      }
    }
  ]
}
